import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// import JSON translation
import translation_en from "./en/translation.json";
import translation_de from "./de/translation.json";
import translation_es from "./es/translation.json";

// i18next plugins
import LanguageDetector from "i18next-browser-languagedetector";

// setup the translations
const resources = {
  en: translation_en,
  de: translation_de,
  es: translation_es
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "en",
    keySeparator: false,
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    detection: {
      order: ['navigator', 'htmlTag'],
    }
  });

export default i18n;
